const util = {
  getDetail(id){
    return new Promise((resolve, reject)=>{
      Util.ajax.get(Util.api.income_group_detail, {
        params: {
          id: id
        }
      }).then((response)=>{
        return response.data;
      }).then((res)=>{
        if(res.code === 1){
          resolve(res.data);
        }else{
          reject({message: res.msg});
        }
      }).catch((e)=>{
        reject(e);
      });
    });
  },
  getReceiptType(type) {
    let text;
    switch (type) {
      case 0:
        text = '收款';
        break;
      case 1:
        text = '计提';
        break;
      default:
        text = '未定义单据类型';
        break;
    }
    return text;
  }
};

export default util;
